export enum Icons {
    Restart = 'refresh',
    Shutdown = 'power_settings_new',
    Reset = 'build',
}
